<template>
  <div class="main" style="margin: 10px;">
    <div class="container" style="height: 55px;">
      <div class="image" >
        <el-image :src="refHeadImage" />
      </div>
      <div class="image" v-if="!isNullValue(store.state.simInfo.data)" @click="goHome()">
        <el-icon :size="35"><ArrowLeft /></el-icon>
      </div>
      <div class="language-btn" >
        <el-button type="primary" size="small" plain @click="setLanguage('zh')" v-if="!isChinese()">中</el-button>
        <el-button type="primary" size="small" plain @click="setLanguage('en')" v-if="isChinese()">EN</el-button>
      </div>
    </div>
    <!-- 查询条件 -->
    <el-row align="middle" class="el-row-margin">
      <el-col :span="18">
        <el-input
          v-model="refSimNo"
          :placeholder="`${getI18n('ICCID/SimNo/手机号', 'ICCID/SimNo/Phone Number')}`"
          clearable
          class="custom-select-height"
        >
          <template #prefix>
            <el-icon
              :size="26"
              @click="pasteFromClipboard"
              style="cursor: pointer; margin-right: 8px; color: #909399;"
            >
              <DocumentCopy />
            </el-icon>
          </template>
          </el-input>
      </el-col>
      <el-col :span="6" style="display: flex; justify-content: flex-end; align-items: center;">
        <el-button type="primary" @click="query()">
          <span class="button-font">{{getI18n('查询', 'Query')}}</span>
        </el-button>
      </el-col>
    </el-row>

    <template v-if="store.state.simInfo.code == 'ok'">
      <template v-if="!isNullValue(store.state.simInfo.data)">
        <SimCard :simNo="refSimNo"/>
        <!-- 显示套餐数据 -->
        <template v-for="plan in store.state.simInfo.data.packageList" :key="plan.orderId">
          <PackageCard :plan="plan"/>
        </template>
      </template>
    </template>
    <template v-else>
      <div class="card bottom10px" >
        <el-row class="card-row" :gutter="20" align="middle">
            <el-col :span="24">
              <span class="warning">{{ store.state.simInfo.message }}</span>
            </el-col>
        </el-row>
        <HelpCenter/>
      </div>
    </template>
    <template v-if="isNullValue(store.state.simInfo.data)">
      <HelpCenter />
    </template>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted } from 'vue'
import { Tickets, ArrowLeft, DocumentCopy } from '@element-plus/icons-vue'
import store from '../store'
import { apiPostData, isNullValue, getI18n, setCookie, getCookie, setLanguage, isChinese, getDomain, getParameterByName } from '../utils'
import HelpCenter from '../components/HelpCenter.vue'
import PackageCard from '../components/PackageCard.vue'
import SimCard from '../components/SimCard.vue'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'QueryOrderView'
})
</script>

<script lang="ts" setup>

// const refSimNo = ref('89852342022040149139')
// const refSimNo = ref('89852342022100442002')
const refSimNo = ref('')
const refHeadImage = ref('')

onMounted(async () => {
  refHeadImage.value = 'images/' + getDomain() + '-logo.png'

  const simNoInCookie = getCookie('simNo')
  if (simNoInCookie) {
    refSimNo.value = simNoInCookie
  }

  const simNo = getParameterByName('simNo')
  console.log('simNo=', simNo)
  if (simNo) {
    refSimNo.value = simNo
    query()
  }
})

function query () {
  queryUserPlan()
}

function queryUserPlan () {
  refSimNo.value = refSimNo.value.replace(/[^a-zA-Z0-9]/g, '')
  console.info('queryUserPlan', refSimNo.value)
  const data = { simNo: refSimNo.value }
  apiPostData('/h5/v1/sim/get-info', data)
    .then(data => {
      if (data !== null && data !== undefined) {
        store.state.simInfo = data
        if (data.code === 'ok') {
          store.state.isQueriedSim = false
          setCookie('simNo', refSimNo.value, 7)
        }
      }
    })
}
function goHome () {
  store.state.simInfo = { code: 'ok' }
  store.state.isQueriedSim = false
}

// 从剪贴板粘贴
const pasteFromClipboard = async () => {
  try {
    const text = await navigator.clipboard.readText()
    if (text) {
      refSimNo.value = text
    } else {
      ElMessage.warning(getI18n('剪贴板为空', 'Clipboard is empty.'))
    }
  } catch (err) {
    // ElMessage.error(getI18n('无法读取剪贴板，请手动粘贴', 'Unable to read clipboard, please paste manually.'))
    console.error(err)
  }
}

</script>

<style scoped>
.button-font {
  color: white;
  font-weight: bold;
}
.container {
  position: relative;
}
.image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  align-items: center;
  display: grid;
}
.language-btn {
  position: absolute;
  top: 50%;
  right: 10px;  /* 靠右偏移 */
  transform: translateY(-50%);  /* 垂直居中 */
  width: auto;
  height: auto;
  z-index: 3;  /* 最上层 */
  display: flex;
  justify-content: flex-end;  /* 内容右对齐 */
}
.el-row-margin {
  margin: 10px;
}
.el-button {
  display: flex;
  justify-content: flex-end;
  height: 40px;
}
.warning {
  color: red;
  font-weight: bold;
  font-size: 24px;
}
/* 设置自定义类的样式 */
.custom-select-height {
    cursor: pointer;
    width: 100%;
  }
@media screen and (min-width: 600px) {
  .main {
    max-width: 600px; /* 或根据需要设置为其他宽度 */
    width: 600px;
    margin: 0 auto; /* 使内容居中 */
    padding: 0 10px; /* 给两边留一些空白 */
  }

  /* 设置自定义类的样式 */
  .custom-select-height {
    height: 40px;
  }
  .custom-select-height ::v-deep .el-input__inner {
    font-size: 24px;
    height: 40px;
  }
  .button-font {
    font-size: 24px;
  }
}
.clipboard-wrapper {
  margin-right: 8px; /* 调整与按钮的距离 */
  display: flex;
  align-items: center;
}
.clipboard-icon {
  color: #909399;
  cursor: pointer;
  transition: color 0.3s;
}
.clipboard-icon:hover {
  color: #409eff;
}
</style>
